import React from 'react';
import ReactDOMServer from 'react-dom/server';

import spreadsheetExampleImg from '../../assets/images/dob_spreadsheet_example.png';
import groceriesChannelAImg from '../../assets/images/help_groceriesChannel_a.png';
import groceriesChannelBImg from '../../assets/images/help_groceriesChannel_b.png';

export default {
    admin: {
        title: "Admin",
        offices: {
            title: "Bureaux",
            cols: {
                location: "Emplacement"
            }
        },
        users: {
            title: "Utilisateurs",
            cols: {
                email: "Courriel",
                fullName: "Nom complet",
                role: "Région/Rôle(s)"
            }
        }
    },
    history: {
        title: "Histoire",
        cols: {
            office: "Bureau",
            action: "Action",
            modifiedBy: "Modifié par",
            date: "Date",
            user: "Utilisateur",
            event: "Événement"
        }
    },
    birthdays: {
        add: "Ajouter un anniversaire",
        delete: "Enlever l'anniversaire",
        deleteMulti: "Enlever les anniversaires",
        edit: "Modifier l'anniversaire",
        spreadsheetHelp: "Cliquez pour ouvrir la documentation d'aide.",
        title: "Anniversaires",
        cols: {
            customization: "Personnalisation",
            date: "Date de naissance",
            name: "Nom"
        },
        fields: {
            date: "Date de naissance",
            description: "Description",
            image: "Image",
            name: "Nom complet",
            sheetUrl: "URL de la feuille de calcul Google",
            title: "Titre"
        },
        help: {
            spreadsheetUpload: {
                brief: "Cliquez pour afficher l'aide",
                content: ReactDOMServer.renderToStaticMarkup(
                    <div>
                        <h2>1. Créer une feuille de calcul</h2>
                        <p>Créez une feuille de calcul à l'aide de Google Documents, d'Excel ou du programme de votre choix.</p>
                        <p>Structurez-le de sorte que les noms apparaissent dans la deuxième colonne et les dates de naissance dans la troisième.</p>
                        <p>Utilisez la première ligne pour les en-têtes ou laissez-les vides.</p>
                        <p>N'hésitez pas à utiliser la première colonne comme bon vous semble; elle ne sera pas utilisée.</p>
                        <p><em>Voici un exemple de la mise en page souhaitée:</em></p>
                        <p><img src={spreadsheetExampleImg} alt="Exemple de tableur"/></p>

                        <h2>2. Télécharger la feuille de calcul</h2>
                        <p><em>** Si vous avez créé votre feuille de calcul dans Google Documents, passez à l'étape suivante.</em></p>
                        <p>Maintenant que vous avez votre feuille de calcul, connectez-vous à <a href="https://drive.google.com/"> Google Drive </a>, puis
                            téléversez-y votre fichier.</p>
                        <p>Si vous ne possédez pas de compte Google et ne souhaitez pas en créer un, n'hésitez pas à contacter Chase Thorne sur
                            MatterMost, et il téléversera volontier le fichier pour vous.</p>

                        <h2>3. Charger les données</h2>
                        <p>Ouvrez la feuille de calcul dans Google Documents.</p>
                        <p>Cliquez sur le bouton bleu "Partager" dans le coin supérieur droit et assurez-vous que les autorisations sont définies comme
                            "Toute personne disposant du lien peut voir".</p>
                        <p>Copiez l'URL du document à partir de la barre d'adresse et collez-la dans le champ de texte.</p>
                        <p>Après l'enregistrement, le processus de chargement des données peut prendre quelques instants.</p>
                    </div>
                )
            }
        }
    },
    buttons: {
        add: "Ajouter",
        archive: "Archiver",
        cancel: "Annuler",
        close: "Fermer",
        confirm: "Confirmer",
        delete: "Supprimer",
        edit: "Modifier",
        pickColor: "Choisissez la couleur",
        restore: "Rétablir",
        submit: "Soumettre",
        submitting: "Soumission..."
    },
    common: {
        actions: "Actions",
        archiveConfirm: "Confirmer l'archivage",
        archiveMultiConfirm: "Êtes-vous sûr de vouloir archiver les éléments sélectionnés?",
        confirmMessage: "Êtes-vous sûr de vouloir ",
        deleteConfirm: "Confirmer la suppression",
        deleteMultiConfirm: "Êtes-vous sûr de vouloir supprimer les éléments sélectionnés?",
        unarchiveMultiConfirm: "Êtes-vous sûr de vouloir désarchiver les éléments sélectionnés?"
    },
    config: {
        basicSettings: "Paramètres de base",
        birthdaySettings: "Paramètres d'anniversaire par défaut",
        defaultImageSettings: "Paramètres d'image par défaut",
        eventSlideFontSettings: "Paramètres de police de diapositive d'événement",
        grocerySettings: "Paramètres d'épicerie",
        polishSettings: "Paramètres de polish",
        roomSettings: "Paramètres des chambres",
        updateFailure: "Échec de l'enregistrement des modifications.",
        updateSuccess: "Configuration mise à jour.",
        tinymceLanguage:"fr_FR",
        fields: {
            common: {
                description: "Description",
                details: "Détails",
                title: "Titre"
            },
            autoReload: "Recharger automatiquement le tableau de bord lors de la mise à jour",
            birthdays: {
                dateOfBirthFontSettings: "Paramètres par défaut de la police de date de naissance",
                displayDeltaAfter: "Affichage après delta",
                displayDeltaBefore: "Affichage avant delta",
                image: "Image",
            },
            spoc: {
                defaultSpocImage: "Image SPOC par Défaut (Taille Maximale de l'Image: 688px X 430px)",
            },
            events: {
                eventUsers: "Utilisateurs d'événements Outlook",
            },
            defaultDuration: "Durée d'affichage par défaut des diapositives",
            groceriesChannel: "Canal Mattermost  de discussion d'épicerie",
            groceriesFontSettings: "Paramètres de police d'élément de liste",
            modules: "Modules",
            polish: {
                sheetId: "Identifiant tableur polish",
                tabName: "Nom de l'onglet de la feuille de calcul polish"
            },
            previewOrientation: "Orientation d'aperçu par défaut",
            rooms: "Salles de conférence",
            timezone: "Fuseau horaire",
            weatherCityId: "Identifiant de la ville (météo)"
        },
        help: {
            birthdays: {
                brief: "Utilisez \"$ NAME\" à la place du nom d'une personne.",
                detailed: ReactDOMServer.renderToStaticMarkup(
                    <div>
                        <h3>Écrire un message générique</h3>
                        <p>Utilisez "$ NAME" à la place du nom d'une personne.</p>
                        <pre>"Joyeux anniversaire, $NAME!"</pre>

                        <h3>Remplace automatiquement dans le nom</h3>
                        <pre>$NAME = "Fred"</pre>
                        <pre>affiche -> "Joyeux anniversaire, Fred!"</pre>
                    </div>
                )
            },
            birthdaysDeltaAfter: {
                brief: "Nombre de jours après l'anniversaire pendant lesquels la diapositive sera visible. \nLa valeur par défaut est un jour."
            },
            birthdaysDeltaBefore: {
                brief: "Nombre de jours avant l'anniversaire pendant lesquels la diapositive sera visible. \nLa valeur par défaut est un jour."
            },
            eventUsers: {
                brief: "Entrez les noms d'utilisateurs, séparés par des virgules.",
                detailed: ReactDOMServer.renderToStaticMarkup(
                    <div>
                        <h3>Recherchez l'adresse e-mail de l'entreprise de la personne.</h3>
                        <pre>cthorne@spiria.com</pre>

                        <h3>Supprimez le "@ spiria.com" de l'e-mail.</h3>
                        <pre>cthorne</pre>

                        <h3>(Facultatif) Ajoutez un autre utilisateur avec un séparateur de virgule</h3>
                        <pre>cthorne, lmeleshchenko</pre>
                    </div>
                )
            },
            groceriesChannel: {
                brief: 'Entrer le nom de votre canal Mattermost',
                detailed: ReactDOMServer.renderToStaticMarkup(
                    <div>
                        <h3>Ouvrir les infos sur le canal</h3>
                        <p>Ouvrez MatterMost et entrez le canal que vous souhaitez utiliser. Cliquez sur le titre et sélectionnez "Afficher les informations" dans le menu.</p>
                        <img src={groceriesChannelAImg} alt="ouvrir les informations sur le canal"/>

                        <h3>Obtenez le nom de la chaîne</h3>
                        <p>Copiez le nom de la chaîne à partir du champ URL.</p>
                        <img src={groceriesChannelBImg} alt="aide à copier le nom du canal"/>
                    </div>
                )
            },
            timezone: {
                brief: 'Entrer votre fuseau horaire',
                detailed: ReactDOMServer.renderToStaticMarkup(
                    <div>
                        <h3>Indice</h3>
                        <p>Commencez à taper dans votre pays / continent et recherchez votre région dans les options.</p>
                        <pre>par exemple. "Can" pour les fuseaux horaires canadiens</pre>

                        <h3>Trouver votre fuseau horaire</h3>
                        <p>Visitez la page d'accueil <a href="https://momentjs.com/timezone/"> Moment Timezone </a>.</p>
                        <p>Faites défiler jusqu'à la carte et passez la souris sur le point le plus proche de votre position.</p>
                        <p>Prenez note du texte au-dessus de la carte. c'est votre fuseau horaire.</p>

                        <h3>Entrer le fuseau horaire</h3>
                        <p>Revenir au formulaire.</p>
                        <p>Commencez à taper dans le fuseau horaire et le système s'auto-complétera.</p>
                    </div>
                )
            },
            weatherCityId: {
                brief: 'Écrivez le nom complet de votre ville, et choisissez la meilleure option.'
            }
        }
    },
    countdown: {
        days: "jours",
        hours: "heures",
        minutes: "minutes",
        seconds: "secondes"
    },
    error: {
        report: {
            button: "Signaler un commentaire",
            message: "Quelque chose a mal tourné et a causé la fermeture de l'application.\n"
                + "Veuillez prendre le temps de soumettre vos commentaires et actualisez la page lorsque vous êtes prêt à continuer.",
            title: "Une erreur est survenue!"
        }
    },
    events: {
        add: "Ajouter un événement",
        archive: "Archiver l'événement",
        archiveMulti: "Archiver les événements",
        delete: "Supprimer l'événement",
        deleteMulti: "Supprimer les événements",
        edit: "Modifier l'événement",
        restore: "Rétablir l'événement",
        title: "Événements",
        unarchiveMulti: "Désarchiver les événements",
        cols: {
            createdBy: "Auteur",
            description: "Description",
            endDate: "Fin",
            order: "Ordre",
            title: "Titre",
            startDate: "Début",
            visibility: "Visibilité"
        },
        fields: {
            backgroundColor: "Couleur de fond",
            calendarEvent: "Événement de calendrier",
            contact: "Informations de contact",
            description: "Description",
            duration: "Durée de la diapositive",
            urlLink:"Lien URL SPOC",
            endDate: "Date de fin",
            imageDefault: "Image (Rapport d'Image Suggéré : 3:2)",
            imageImage: "Image (Rapport d'Image Suggéré : 9:16)",
            isArchived: "Archivé",
            isCountdown: "Compte à rebours",
            location: "Emplacement",
            participants: "Participants",
            startDate: "Date de début",
            time: "Temps",
            timeOverride: "Entrez l'heure manuellement",
            title: "Titre",
            type: "Type de diapositive",
            spocLayout: "Disposition SPOC",
            spocImage: "Image SPOC (Taille d'Image Suggérée: 413px X 430px)",
            spocFullImage: "Image SPOC (Taille d'Image Suggérée: 688px X 430px)",
            hideTitleOnSpoc: 'Masquer le titre sur SPOC'
        }
    },
    eventPreview: {
        button: "Aperçu",
        rotate: "Pivoter",
        title: "Aperçu de la diapositive",
        spoc: "Spoc",
    },
    forms: {
        fileDrop: {
            dropHere: "Sélectionnez un fichier et glissez-le ici pour le téléverser."
        },
        fonts: {
            lineHeight: "Interligne",
            size: "Taille de police",
            units: "Unités",
            weight: "Poids de la police"
        },
        imageSettings: "Tableau de bords - Paramètres d'image avancés",
        imageSettingsFields: {
            objectFit: "Ajustement d'objet",
            horizontalPosition: "Position horizontale",
            verticalPosition: "Position verticale"
        },
        spocImageSettings: "SPOC - Paramètres d'image avancés",
        spocImageSettingsFields: {
            objectFit: "Ajustement d'objet",
            horizontalPosition: "Position horizontale",
            verticalPosition: "Position verticale"
        },
        optional: "Champs optionnels",
        required: "Champs obligatoires"
    },
    groceries: {
        add: "Ajouter à l'épicerie",
        delete: "Retirer de l'épicerie",
        deleteMulti: "Retirer de l'épiceries",
        edit: "Modifier l'épiceries",
        title: "Épicerie",
        cols: {
            name: "Nom",
            requestedBy: "Demandé par"
        },
        fields: {
            name: "Article d'épicerie",
            requestedBy: "Demandé par"
        },
        slides: {
            title: "Tout ce que tu peux manger!"
        }
    },
    help :{
        seeLess: "Cliquez ici pour voir moins",
        seeMore: "Cliquez ici pour en voir plus",
        title: "Aidez-moi"
    },
    login: {
        dashboard: "Tableau de bord",
        email: "Courriel",
        forgotPassword: "Mot de passe oublié?",
        password: "Mot de passe",
        return: "Retour au tableau de bord",
        signIn: "Connecter",
        errors: {
            "auth/wrong-password": "Le mot de passe est invalide ou l'utilisateur ne possède pas de mot de passe.",
            "auth/user-not-found": "Il n'y a pas d'utilisateur correspondant à cet identifiant. L'utilisateur peut avoir été supprimé."
        }
    },
    messages: {
        cols: {
            datetime: "Date",
            text: "Message",
            username: "Nom d'utilisateur"
        }
    },
    navigation: {
        admin: "Admin",
        all: "Tout",
        birthdays: "Anniversaires",
        config: "Configurations",
        events: "Événements",
        groceries: "Épicerie",
        messages: "Messages",
        offices: "Bureaux",
        users: "Utilisateurs",
        videos: "Vidéos",
        systemAnnouncements: "Annonces de Système"
    },
    offices: {
        add: "Ajouter un bureau",
        archive: "Archiver le bureau",
        delete: "Retirer le bureau",
        cols: {
            key: "Emplacement"
        },
        fields: {
            key: "Emplacement"
        }
    },
    systemAnnouncements: {
        add: "Ajouter une annonce de système",
        edit: "Modifier l'annonce du système",
        delete: "Supprimer l'annonce",
        cols: {
            title: "Titre",
            announcement: "Annonce",
            startDate: "Date de début",
            endDate: "Date de fin"
        },
        fields: {
            title: "Titre",
            announcement: "Annonce",
            startDate: "Date de début de l'annonce",
            endDate: "Date de fin de l'annonce"
        },
    },
    profile: {
        edit: "Modifier le profil",
        logout: "Déconnecter",
        resetPassword: "Réinitialiser le mot de passe",
        passwordResetMessage: "Êtes-vous sûr de vouloir réinitialiser votre mot de passe?",
        passwordResetSuccess: "Vous devriez recevoir un courriel de réinitialisation du mot de passe sous peu."
    },
    rooms: {
        available: "Disponible",
        forTime: "pendant {time}"
    },
    splash: {
        select: "Sélectionnez un Tableau de bord:",
        goToAdmin: "Aller au panneau d'administration"
    },
    tables: {
        archivedData: "Données archivéesa",
        noData: 'Pas de données',
        scheduledAnnouncements: "Annonces programmées",
        pastAnnouncements: "Annonces passées"
    },
    types: {
        imageFit: {
            contain: "Contenir",
            cover: "Couvrir",
            fill: "Remplir (Défaut)"
        },
        imagePosition: {
            bottom: "Bas",
            center: "Centre (Défaut)",
            left: "Gauche",
            right: "Droite",
            top: "Haut"
        },
        module: {
            birthdays: "Anniversaires",
            groceries: "Épicerie",
            messages: "Messages",
            polish: "Polish",
            rooms: "Salles de conférence",
            videos: "Vidéos",
            spoc: "SPOC"
        },
        orientation: {
            landscape: "Paysage",
            portrait: "Portrait"
        },
        role: {
            admin: "Admin",
            all: "Tout",
            superAdmin: "Super admin"
        },
        slide: {
            default: "Défaut",
            image: "Image"
        },
        spocLayout: {
            titleOnTop: "Titre en Haut",
            fullImage: "Image Complète",
            visualOnTop: "Visuel en Haut"
        }
    },
    users: {
        add: "Ajouter un utilisateur",
        delete: "Supprimer un utilisateur",
        edit: "Modifier un utilisateur",
        cols: {
            email: "Courriel",
            fullName: "Nom complet",
            role: "Région/Rôle(s)"
        },
        fields: {
            email: "Email",
            fullName: "Nom complet",
            role: "Region/Role(s)"
        }
    },
    videos: {
        add: "Ajouter une vidéo",
        archive: "Archiver la vidéo",
        delete: "Supprimer la vidéo",
        edit: "Modifier la vidéo",
        restore: "Rétablir la vidéo",
        cols: {
            title: "Titre",
            url: "URL"
        },
        fields: {
            title: "Titre",
            url: "URL"
        }
    }
};


// WEBPACK FOOTER //
// ./src/constants/locale/fr-CA.js